const y = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, e = {
  DatePicker: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 0,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "MM-yyyy",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, t = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, r = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, a = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, o = {
  DatePicker: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 1,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "MM/yyyy",
    quarterFormat: "qqq yyyy",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, m = {
  DatePicker: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 1,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "MM/yyyy",
    quarterFormat: "qqq yyyy",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, F = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, M = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, d = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 0,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, T = {
  DatePicker: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 0,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "MM/yyyy",
    quarterFormat: "qqq yyyy",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, n = {
  DatePicker: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 0,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "MM.yyyy",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, i = {
  DatePicker: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy/MM",
    quarterFormat: "yyyy/qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, s = {
  DatePicker: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy/MM",
    quarterFormat: "yyyy/qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
}, q = {
  DatePicker: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    dayFormat: "eeeeee",
    firstDayOfWeek: 6,
    monthBeforeYear: !0,
    monthFormat: "MMM",
    monthTypeFormat: "yyyy-MM",
    quarterFormat: "yyyy-qqq",
    yearFormat: "yyyy",
    yearTypeFormat: "yyyy"
  },
  SortFilter: {
    aToZ: "A-Z",
    zToA: "Z-A"
  }
};
export {
  y as da,
  e as de,
  t as enUS,
  r as es,
  a as fi,
  o as frCA,
  m as frFR,
  F as hr,
  M as hu,
  d as it,
  T as nl,
  n as no,
  i as ptBR,
  s as ptPT,
  q as sv
};
